import { TipoConceptoCriterioRetrocomisionEnergiaEnum, type CreateCriterioRetrocomisionEnergiaModel, type DetailCriterioRetrocomisionEnergiaModel } from '@api/api';

export class CreateRetrocomisionEnergia implements CreateCriterioRetrocomisionEnergiaModel {

  Id: string = '';
  IdEmpresaServicios: string = '';
  IdGrupo: string = '';
  TipoConcepto: TipoConceptoCriterioRetrocomisionEnergiaEnum = TipoConceptoCriterioRetrocomisionEnergiaEnum.Oferta;
  PeriodoHasta: number = 0;
  AplicaPersonaFisica: boolean = true;
  AplicaPersonaJuridica: boolean = true;
  TarifaAcceso: string[] = [];
  Importe: number = 0;

  constructor(data?: Partial<CreateRetrocomisionEnergia>) {
    Object.assign(this, data);
  }

  public createFromRetrocomisionDetail(criterioRetrocomision: DetailCriterioRetrocomisionEnergiaModel): CreateRetrocomisionEnergia {
    Object.assign(this, criterioRetrocomision);
    return this;
  }

}